import { useState } from "react";
import { Check } from "lucide-react";
import { targetLabel } from "@/lib/events";

export const NoteStep = ({ draft, match, onSave }) => {
  const [note, setNote] = useState("");
  const who = draft.target ? `${match[draft.team].name} · ${targetLabel(draft)}` : "Sem identificação";
  return (
    <div>
      <p className="label-caps mb-2">{who} · Zona {draft.zone}</p>
      <textarea data-testid="event-note-input" autoFocus value={note} onChange={(e) => setNote(e.target.value)} rows={4}
        placeholder="Escreva uma observação (motivo, descrição do lance...)"
        className="w-full bg-[#131313] border border-white/15 p-4 text-base focus:outline-none focus:border-[#CCFF00]" />
      <div className="flex flex-wrap justify-end gap-3 mt-4">
        <button data-testid="event-note-skip" onClick={() => onSave("")} className="tap h-14 px-6 border border-white/20 font-semibold hover:bg-white/10">
          Guardar sem nota
        </button>
        <button data-testid="event-note-save" onClick={() => onSave(note.trim())}
          className="tap h-14 px-8 bg-[#CCFF00] text-black font-display text-xl font-bold uppercase flex items-center gap-2 hover:brightness-110">
          <Check size={20} /> Guardar
        </button>
      </div>
    </div>
  );
};
